import posthog from 'posthog-js';

// Initialize PostHog with environment variables
const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;

export const initPostHog = () => {
  if (POSTHOG_KEY && POSTHOG_HOST) {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      person_profiles: 'identified_only',
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: true,
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
          password: true,
        },
      },
    });
  }
};

// Identify user after login
export const identifyUser = (user) => {
  if (!POSTHOG_KEY) return;
  
  posthog.identify(user.id, {
    email: user.email,
    role: user.role,
    building_id: user.buildings?.[0] || null,
    name: user.name,
  });
};

// Reset user on logout
export const resetUser = () => {
  if (!POSTHOG_KEY) return;
  posthog.reset();
};

// Track custom events
export const trackEvent = (eventName, properties = {}) => {
  if (!POSTHOG_KEY) return;
  posthog.capture(eventName, properties);
};

// Track page/module visits
export const trackModuleVisit = (module) => {
  trackEvent('module_visited', { module });
};

// Export posthog instance for direct usage if needed
export { posthog };
